import { TestCam } from '@/components/scenes';

export const App = () => {
  return <TestCam />;
};
